import { CountrySelectionService } from './../../../services/country-selection/country-selection.service';
import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { WorkbenchModule } from '@workbench/angular';
import { TranslationService } from 'src/app/services/translation.service';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-country-selector',
    standalone: true,
    imports: [WorkbenchModule, TranslateModule, CommonModule],
    templateUrl: './country-selector.component.html',
    styleUrl: './country-selector.component.scss',
})
export class CountrySelectorComponent implements OnInit {
    public countryList: any[] = [{ title: '', code: '' }];
    public hasUserConfirmedCountry: boolean = false;
    public userOriginCountry = '';

    constructor(private readonly _translationService: TranslationService, private readonly _countrySelectionService: CountrySelectionService) {}

    ngOnInit(): void {
        this.countryList = this._translationService.cpSecrets.countries
            .filter((country: any) => country.flag === true)
            .map((country: any) => {
                return {
                    title: country.name,
                    code: country.code,
                    region: country.region
                };
            });
    }

    selectCountry(e: any): void {
        this.userOriginCountry = e?.detail?.value?.label;
    }

    onInputCountryChange(event: any) {
        if (event?.detail?.value === '') {
            this.userOriginCountry = '';
        }
    }

    onCheckBoxSelect(e: any) {
        this.hasUserConfirmedCountry = e?.detail?.checked;
    }

    onCountrySelectClick() {
        if (this.userOriginCountry && this.userOriginCountry !== '' && this.hasUserConfirmedCountry) {
            const countryDetails = this.countryList.find(country => country.title === this.userOriginCountry);
            this._countrySelectionService.setCountry(JSON.stringify(countryDetails))
        }
    }
}
